module.exports = __webpack_public_path__ + "img/restaurant-bathroom.ae495270.svg";